<template>
    <div class="row">
        <template v-if="activeCustomer.firstname">
            <router-view name="shippingType" />
            <router-view name="shippingAddress" />
            <router-view name="deliverFrom" />
            <router-view name="deliveryType" />
            <router-view name="couponCode" />
            <router-view name="voucherCode" />
            <router-view name="schedule" />
            <router-view name="orderSummary" />
            <router-view name="commendToShoppers" />
            <router-view name="options" />
            <router-view name="requestTaxInvoice" />
        </template>

        <template v-else>
            <div class="q-ma-lg text-h6">Please choose customer.</div>
        </template>
    </div>
</template>

<script>
// import DialogAlert from "@/ui/components/DialogAlert";
import { mapState } from "vuex";
export default {
    name: "Checkout",
    computed: {
        ...mapState({
            activeCustomer: (state) => state["activeCustomer"]["customer"],
            // inStockList: (state) => state["cartData"]["inStockList"],
            // outOfStockList: (state) => state["cartData"]["outOfStockList"],
            // overStockList: (state) => state["cartData"]["overStockList"],
            // unavailableList: (state) => state["cartData"]["unavailableList"],
            loading: (state) => state["cartData"]["loading"],
        }),
    },
    methods: {
        getCommendToShoppers(){
            return this.$refs["commendToShoppers"].get();
        }
    }
};
</script>
